import { render, staticRenderFns } from "./view.vue?vue&type=template&id=76b0f9af&scoped=true&"
import script from "./view.vue?vue&type=script&lang=ts&"
export * from "./view.vue?vue&type=script&lang=ts&"
import style0 from "./view.vue?vue&type=style&index=0&id=76b0f9af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b0f9af",
  null
  
)

export default component.exports